// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
	register: '/auth/apply',
	login: '/auth/login',
	logout: '/auth/logout',
	//
	activeUser: '/auth/activate',
	resendEmail: '/auth/resend_activate_email',
	//
	forgotPassword: '/auth/forgot_password',
	resetPassword: '/account/reset_password_login',
	resetPasswordNoLogin: '/auth/reset_password',
	checkTokenUsed: '/auth/token_used',
};

// ----------------------------------------------------------------------

const register = (request, fingerprint) => axios.post(`${ API_ENDPOINTS.register }`, { ...request });

const login = (request, fingerprint) => axios.post(`${ API_ENDPOINTS.login }`, { ...request });

const logout = () => axios.post(`${ API_ENDPOINTS.logout }`);

const activeUser = (request) => axios.post(`${ API_ENDPOINTS.activeUser }`, { ...request });

const resendEmail = (request) => axios.post(`${ API_ENDPOINTS.resendEmail }`, { ...request });

const forgotPassword = (request) => axios.post(`${ API_ENDPOINTS.forgotPassword }`, { ...request });

const resetPassword = (request) => axios.post(`${ API_ENDPOINTS.resetPassword }`, { ...request });

const resetPasswordNoLogin = (request) => axios.post(`${ API_ENDPOINTS.resetPasswordNoLogin }`, { ...request });

const checkTokenUsed = (params) => axios.get(`${ API_ENDPOINTS.checkTokenUsed }`, { params });

// ----------------------------------------------------------------------

export {
	register as registerAPI,
	login as loginAPI,
	logout as logoutAPI,
	//
	activeUser as activeUserAPI,
	resendEmail as resendEmailAPI,
	//
	forgotPassword as forgotPasswordAPI,
	resetPassword as resetPasswordAPI,
	resetPasswordNoLogin as resetPasswordNoLoginAPI,
	checkTokenUsed as checkTokenUsedAPI,
};
